import React, { useEffect, useState, useCallback, useMemo } from "react";
import { changeSearchTab } from "js/searches/tabs/actions";
import HowdyBox from "js/searches/howdy_box/howdy_box";


const HowdyBoxSearch = ({ context }) => {
  const [activeTabId, setActiveTabId] = useState();
  const [searchTabs, setSearchTabs] = useState({});
  const searchTabStore = context.getStore("SearchTabStore");
  const paramStore = context.getStore("ParamStore");

  const updateTabs = useCallback(() => {
    setSearchTabs(searchTabStore.getAll() || {});
  }, [searchTabStore]);

  const tabsByTitle = useMemo(() =>
    Object.fromEntries(Object.values(searchTabs).map(tab => [tab.title, tab])),
    [searchTabs]
  );

  const updateActiveTab = useCallback((id) => {
    const currentTabId = id ?? paramStore.get("search_tab_id");
    if (currentTabId) setActiveTabId(currentTabId);
  }, [paramStore]);

  useEffect(() => {
    updateActiveTab();
    updateTabs();

    searchTabStore.addChangeListener(updateTabs);
    paramStore.addChangeListener(updateActiveTab);

    return () => {
      searchTabStore.removeChangeListener(updateTabs);
      paramStore.removeChangeListener(updateActiveTab);
    };
  }, [searchTabStore, paramStore]);


  const handleOptionClick = (option) => {
    const tab = tabsByTitle[option.tabTitle]

    if (tab) {
      context.executeAction(changeSearchTab, { ...tab, previousTabId: activeTabId });
      if (option.aiToolOption) {
        const url = new URL(window.location);
        url.searchParams.set("ai_tool", option.aiToolOption);
        window.history.replaceState({}, "", url);
      }
      updateActiveTab(tab.id);
    }
  };

  return (
    <HowdyBox
      howdyBoxClassName="lg:gap-16"
      searchTabs={searchTabs}
      activeTabId={activeTabId}
      onClick={handleOptionClick}
    />
  );
};

export default HowdyBoxSearch;
